import { ACTIONS, ActionType } from "actions/recommends/types";
import produce, { Draft } from "immer";
import { LoadingState } from "types/api";
import { RecommendsState } from "./types";

export const initialState = {
    data: null,
    status: LoadingState.idle,
};

const recommends = produce((state: Draft<RecommendsState>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.GET_RECOMMENDS_REQUEST:
            state.status = LoadingState.loading;
            break;

        case ACTIONS.GET_RECOMMENDS_SUCCESS:
            state.status = LoadingState.success;
            state.data = action.payload;
            break;

        case ACTIONS.GET_RECOMMENDS_FAILURE:
            state.status = LoadingState.failure;
            break;
    }
}, initialState);

export default recommends;
